import React, { useEffect, useState } from 'react';
import { FontIcon, mergeStyles, IStyle, getTheme, DefaultButton, PrimaryButton } from '@fluentui/react';

interface IBwjPaginatorProps {
  numberOfPages: number;
  currentPageIndex: number;
  onPageChangeRequested: (requestedIndex: number) => void;
  maxDisplayedPageButtons?: number;
}

const paginatorStyle: IStyle = {
  margin: 0,
  padding: 0,
  alignSelf: 'stretch',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 30,

  '& button': {
    minWidth: 50,
    marginRight: 10,
    '& ::last-child': {
      margin: 0,
    },
  },
};

const DEFAULT_MAX_DISPLAYED_PAGE_BUTTONS = 5;

const getMaxDisplayedPageButtons = (givenMaxButtons: number | undefined) => {
  return (!!givenMaxButtons && givenMaxButtons > 0) ?
    givenMaxButtons : DEFAULT_MAX_DISPLAYED_PAGE_BUTTONS;
};

export const BwjPaginator: React.FunctionComponent<IBwjPaginatorProps> = (props) => {

  const { numberOfPages, currentPageIndex, maxDisplayedPageButtons } = props;
  const [buttonIndices, setButtonIndices] = useState<number[]>([]);

  const theme = getTheme();
  const paginatorClass = mergeStyles([
    paginatorStyle,
    {
      backgroundColor: theme.palette.neutralLighterAlt,
      color: theme.palette.neutralSecondary,
    },
  ]);

  useEffect(() => {
    const maxButtons = getMaxDisplayedPageButtons(maxDisplayedPageButtons);
    const numPageButtons = numberOfPages < maxButtons ? numberOfPages : maxButtons;
    let firstButtonIndex = 0;
    if(numberOfPages > maxButtons) {
      const leftOffset = Math.floor((numPageButtons - 1) / 2);
      firstButtonIndex = currentPageIndex - leftOffset;
      firstButtonIndex = firstButtonIndex >= 0 ? firstButtonIndex : 0;

      const lastButtonIndex = firstButtonIndex + (numPageButtons - 1);
      if(lastButtonIndex >= numberOfPages) {
        firstButtonIndex = numberOfPages - numPageButtons;
      }
    }

    const bi = [];
    for(let x = 0, l = numPageButtons; x < l; x++) {
      bi.push(firstButtonIndex + x);
    }
    setButtonIndices(bi);
  }, [numberOfPages, currentPageIndex, maxDisplayedPageButtons]);

  return (
    <div className={paginatorClass}>
      {!!buttonIndices.length && buttonIndices[0] > 0 &&
      <div>
        <DefaultButton onClick={() => props.onPageChangeRequested(0)}>
          <FontIcon iconName='DoubleChevronLeft' />
        </DefaultButton>
        <DefaultButton onClick={() => props.onPageChangeRequested(currentPageIndex - 1)}>
          <FontIcon iconName='ChevronLeft' />
        </DefaultButton>
      </div>}

      {buttonIndices.map(index => index === currentPageIndex ?
      <PrimaryButton key={index} onClick={() => props.onPageChangeRequested(index)}>{index + 1}</PrimaryButton>
      :
      <DefaultButton key={index} onClick={() => props.onPageChangeRequested(index)}>{index + 1}</DefaultButton>)}

      {!!buttonIndices.length && (buttonIndices[buttonIndices.length - 1] + 1) < numberOfPages &&
      <div>
        <DefaultButton onClick={() => props.onPageChangeRequested(currentPageIndex + 1)}>
          <FontIcon iconName='ChevronRight' />
        </DefaultButton>
        <DefaultButton onClick={() => props.onPageChangeRequested(numberOfPages - 1)}>
          <FontIcon iconName='DoubleChevronRight' />
        </DefaultButton>
      </div>}
    </div>
  );
};
